import {
	FormControl,
	IconButton,
	Input,
	InputAdornment,
	InputLabel,
	List,
	ListItem,
	ListItemText,
	TextField,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import config from "react-global-configuration";
import { toast } from "react-toastify";
import Backdrop from "../../Backdrop/Backdrop";
import Modal from "../../Modal/Modal";

const CondicoesPagamento = (props, ref) => {
	const [modalOpen, SetModalOpen] = useState(false);
	const [formData, SetFormData] = useState({});
	const [searchResults, SetSearchResults] = useState();
	const [searchResultsFilter, SetSearchResultsFilter] = useState();
	const [CondicoesPagamentoelected, setCondicoesPagamentoelected] = useState(
		""
	);
	const [loading, SetLoading] = useState(false);
  const { refreshPaymentTerms, loadingRefresh } = props;
  
	useEffect(() => {
		SetLoading(true);
		axios
			.get(config.get("url_api") + "totvs/condicao-pagamento/lista")
			.then((response) => {
				if (response.data.success) {
					SetSearchResults(response.data.condicoesPagamento);
					SetSearchResultsFilter(response.data.condicoesPagamento);
				} else {
					SetSearchResults([]);
				}

				SetLoading(false);
			})
			.catch((error) => {
				SetLoading(false);
			});
	}, []);

	const selecionaCondicao = () => {
		SetLoading(true);
    loadingRefresh(true);

		axios
			.get(
				config.get("url_api") +
					"totvs/condicao-pagamento/detalhes?cCodigo=" +
					CondicoesPagamentoelected.cCodigo +
					"&nValor=1000&dEmissao=" +
					moment(props.formData["dEmissao"]).format("YYYY-MM-DD")
			)
			.then((response) => {
				if (response.data.success) {
					props.aplicaParcelas({
						cCondicaoPagamentoParcelas: response.data.condicaoPagamento,
						cCondicaoPagamento: CondicoesPagamentoelected.cCodigo,
					});

					SetModalOpen(false);
				} else {
					toast.error("Erro ao recuperar dados da parcela.");
				}

				SetLoading(false);
        loadingRefresh(false);
			})
			.catch((error) => {
				toast.error("Erro ao recuperar dados da parcela. - " + error);
				SetLoading(false);
        loadingRefresh(false);
			});
	};

	const filterResult = (name) => {
		let data = [];

		if (name !== "" && searchResults) {
			searchResults.forEach((item) => {
				if (
					item.cCodigo.indexOf(name) !== -1 ||
					item.cNome.toLowerCase().indexOf(name.toLowerCase()) !== -1
				) {
					data.push(item);
				}
			});
		} else {
			data = searchResults;
		}

		SetFormData({ name: name });
		SetSearchResultsFilter(data);
	};

  useEffect(() => {
    if(CondicoesPagamentoelected){
      selecionaCondicao();
    }
  }, [CondicoesPagamentoelected, refreshPaymentTerms]);


	return (
		<React.Fragment>
			<FormControl fullWidth>
				<InputLabel htmlFor="standard-adornment-password">
					Forma de pagamento
				</InputLabel>
				<Input
					id={"cVendedor"}
					type={"text"}
					value={CondicoesPagamentoelected && CondicoesPagamentoelected?.cNome}
					margin="dense"
					error={CondicoesPagamentoelected === ""}
					placeholder={"Selecione a forma de pagamento"}
					required
					readOnly
					fullWidth
					endAdornment={
						<InputAdornment position="end">
							<IconButton onClick={(e) => SetModalOpen(true)}>
								<Edit />
							</IconButton>
						</InputAdornment>
					}
				/>
			</FormControl>

			{modalOpen && (
				<Backdrop>
					<Modal
						size="lg"
						title="Buscar condições de pagamento"
						onCancel={() => {
							SetModalOpen(false);
						}}
						onConfirmLabel="selecionar condição de pagamento"
						onCancelTopo
						saving={loading}
					>
						{/* {loading ? <AutorenewIcon className="spin" /> : ""} */}
						{!loading && searchResultsFilter && searchResults.length > 0 && (
							<React.Fragment>
								<div className="scroll-condicao-pagamentos">
									<TextField
										margin="dense"
										id="buscar"
										name="buscar"
										label="Buscar por"
										autoComplete="off"
										fullWidth
										autoFocus
										value={formData && formData.name ? formData.name : ""}
										onChange={(e) => filterResult(e.target.value)}
									/>
									<List component="nav" aria-label="secondary mailbox folders">
										<div className="addProductGroups__container">
											{searchResultsFilter.map((condicaoPagamento) => {
												return (
													<ListItem
														button
														key={condicaoPagamento.cCodigo}
														onClick={() => setCondicoesPagamentoelected(condicaoPagamento)}
													>
														<ListItemText
															primary={condicaoPagamento.cNome}
															secondary={
																condicaoPagamento.cCodigo +
																" | " +
																condicaoPagamento.cCondicao
															}
														/>
													</ListItem>
												);
											})}
										</div>
									</List>
								</div>
							</React.Fragment>
						)}
						{!loading && searchResults && searchResultsFilter.length === 0 && (
							<div>Nenhuma condição encontrada.</div>
						)}
					</Modal>
				</Backdrop>
			)}
		</React.Fragment>
	);
};

export default CondicoesPagamento;
